module.exports = __webpack_public_path__ + "img/Mafia Syndicate.5f75a6a6.jpg";